import request from 'ykd-base/request'
import { NewPage, NewPageParam } from '@/model/common/newPage'
import MyTopicGroup from '@/model/exam/myTopicGroup'

export interface QueryMyTopicGroupParam extends NewPageParam {
  /**
   * 账户ids
   */
  accountIds?: string[]

  /**
   * 试卷ids
   */
  topicGroupIds?: string[]

  /**
   * 我的试卷ids
   */
  myTopicGroupIds?: string[]

  /**
   * 公司id
   */
  companyId?: string

  myTopicGroupStatus?: string

  /**
   * 计划id
   */
  examPlanId?: string

  /**
   * 开始时间
   */
  startTime?: string

  /**
   * 结束时间
   */
  endTime?: string
}

export async function queryMytopicGroup(
  param: QueryMyTopicGroupParam
): Promise<NewPage<MyTopicGroup>> {
  const res = await request<NewPage<MyTopicGroup>>({
    method: 'GET',
    biz: 'done',
    url: '/mytopicgroup/queryPaging',
    params: {
      pagination: param.pagination,
      pageSize: param.pageSize,
      // accountIds: param.accountIds!.join(','),
      topicGroupIds: param.topicGroupIds!.join(','),
      companyId: param.companyId
    }
  })
  return res && res.data
}

export async function queryPagingUserName(
  param: QueryMyTopicGroupParam
): Promise<NewPage<MyTopicGroup>> {
  const res = await request<NewPage<MyTopicGroup>>({
    method: 'GET',
    biz: 'done',
    url: '/mytopicgroup/query/username',
    params: {
      pagination: param.pagination,
      pageSize: param.pageSize,
      status: param.myTopicGroupStatus,
      topicGroupIds: (param.topicGroupIds || []).join(','),
      accountIds: (param.accountIds || []).join(','),
      examPlanId: param.examPlanId,
      startTime: param.startTime,
      endTime: param.endTime
    }
  })
  return res && res.data
}
